// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {RefObject, useEffect, useRef, useState} from 'react';

type t_use_hover = <T extends HTMLElement>()=>[RefObject<T>, boolean];

export const use_hover: t_use_hover = <T extends HTMLElement>()=>{
    const ref = useRef<T>();
    const [state, set_state] = useState(false);
    const on_hover = ()=>set_state(true);
    const on_out = ()=>set_state(false);
    useEffect(()=>{
        if (!ref.current)
            return;
        ref.current.addEventListener('mouseover', on_hover);
        ref.current.addEventListener('mouseout', on_out);
        return ()=>{
            ref.current?.removeEventListener('mouseover', on_hover);
            ref.current?.removeEventListener('mouseout', on_out);
        };
    }, [ref]);
    return [ref, state];
};
